import React from 'react';
import PropTypes from 'prop-types';

import '../client/scss/NavsAsideExtends.scss';

const NavsAsideExtends = ({ User, t, i18n }) => {
  return (
    <div id="NavsAsideExtends_DEMO" className="NavsAsideExtends">
      <div className="btn--demo text-center pt-4">NavsAside Extends Demo</div>
    </div>
  );
};

export default NavsAsideExtends;

NavsAsideExtends.propTypes = {
  User: PropTypes.object,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
};
